﻿$.fn.dxCtrlDossierUpdateBc = function custom_dxCtrlDossierUpdateBc(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrldossierupdatebc dx-ctrl");
        this.createInstance(new cdxCtrlDossierUpdateBc(this, option));
    }
    return this;
}

window.cdxCtrlDossierUpdateBc = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();

        var dxCtrlImage = $("<div style='width:100%;height:100%;'/>").appendTo(container).dxCtrlImageData({
            bddCtrl: option.bddCtrl,
            size: 200,
            data: option.data,
            showTextOnImage: false,
            showText: false,
            fontSizeText: "30px",
            //noDataText: "(aucune image)",
            allowDisplayIcone:true
        }).dxCtrlImageData("instance");

        var dxCtrlObjet = $("<div style='margin:10px 0;'/>").appendTo(container).dxCtrlTextBox({
            labelMode: 'floating',
            label: "Nom du dossier",
            value: option.data.objet,
            onValueChanged: function (e) {
                isDirtyObjetExp = true
                option.data.objet = ((e.value != null) ? e.value : "")
                option.bddCtrl.getObjet(option.data).mSaveChamp("objet")
            }
        }).dxCtrlTextBox("instance")

        var dxCtrlComment = $("<div style='margin:10px 0;'/>").appendTo(container).dxCtrlTextBox({
            labelMode: 'floating',
            label: "Sous titre du dossier",
            value: option.data.body_txt,
            onValueChanged: function (e) {
                isDirtyObjetExp = true
                option.data.body_txt = ((e.value != null) ? e.value : "")
                option.bddCtrl.getObjet(option.data).mSaveChamp("body_txt")
            }
        }).dxCtrlTextBox("instance")

        $("<div/>").appendTo(container).dxCtrlBcLstDossier({
            labelMode: "floating",
            label: "Dossier parent du dossier",
            bddCtrl: option.bddCtrl,
            value: option.data.id_bc_dossier_parent,
            onValueChanged: function (idDossierBc) {
                if ((typeof option.data.id_bc_dossier == "undefined" && typeof idDossierBc == "undefined") ||
                    option.data.id_bc_dossier == idDossierBc) {
                    mConstruit()
                    mNotify("Le dossier sélectionné est identique","warning",6000)
                } else {
                    option.data.id_bc_dossier_parent = idDossierBc
                    option.bddCtrl.getObjet(option.data).mSaveChamp("id_bc_dossier_parent")
                }
            }
        })

        var dxBcAppli = $("<div/>").appendTo(container).dxCtrlBcChkLienAppli({
            bddCtrl: option.bddCtrl,
            data: option.data
        }).dxCtrlBcChkLienAppli("instance")
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();
}